<template lang="pug">
b-modal#forgotPasswordModal.modal(
  centered,
  hide-footer="",
  title="Forgot Password",
  tabindex="-1",
  aria-labelledby="forgotPasswordModal",
  aria-hidden="true"
)
  p Enter the corporate email address associated with your EETI member account.
  form(@submit="submitForm")
    .form-group
      input#mail.form-control.bg-light.border-0(
        type="email",
        aria-describedby="emailHelp",
        placeholder="E-mail",
        v-model="email",
        required
      )
    button.btn.btn-primary.btn-block(type="submit") Send
</template>

<script>
import { resetPassword } from "@/api/user";

export default {
  name: "DialogForgotPassword",
  data() {
    return {
      email: "",
    };
  },
  methods: {
    submitForm(e) {
      e.preventDefault();

      let inputData = {
        email: this.email,
      };
      resetPassword(inputData)
        .then(() => {
          this.$emit("onSendPasswordSuccess", this.email);
        })
        .catch(() => {
          this.$emit("onSendPasswordFail");
        });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  background-color: #082b6b;
  border-color: #082b6b;

  &:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }
}

.bg-light {
  background-color: #eee !important;
}

::v-deep .modal-header {
  border: 0;
  padding-bottom: 0 !important;
}

small {
  font-weight: 300;
}

textarea.form-control {
  min-height: 100px;
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
